import Comment from "%/dynamic-component-editor/standard-pages/comment-page/Comment.vue";
import Comments from "%/dynamic-component-editor/standard-components/comments-widget/Comments.vue";
import CommentInput from "%/dynamic-component-editor/standard-elements/comments-widget/CommentInput.vue";
import SubmitCommentButton from "%/dynamic-component-editor/standard-components/comments-widget/SubmitCommentButton.vue";
import AddCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/AddCommentButton.vue";
import CancelCommentButton from "%/dynamic-component-editor/standard-elements/comments-widget/CancelCommentButton.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyComment extends LegacyEntity {
  // Builder palette for a `comment` context: beyond the read-only Comment thread,
  // expose the composer set (list + input + submit/add/cancel) for the reply flow.
  get elements() {
    return {
      Comment,
      Comments,
      CommentInput,
      SubmitCommentButton,
      AddCommentButton,
      CancelCommentButton,
    };
  }
}
